import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { dateCell } from 'items/ItemList';
import BootstrapTable from 'react-bootstrap-table-next';
import Loading from 'apa/components/Loading';
import { TrainingOverviewLink } from 'customers/TrainingList';
import { Button, ButtonGroup, Form, FormGroup, Col } from 'reactstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import Dialog from 'apa/containers/Dialog';
import { BaseUrl } from '../../BaseUrl/BaseUrl';

@connect(
    state => ({
        token: state.apa.token
    })
)
class TrainingArchive extends Component {

    constructor(props) {
        super(props);
        this.uuid = props.uuid;
        this.state = {
            isOpen: false
        }
    }

    render() {
        const { uuid } = this.props
        const toggle = () => this.setState({ isOpen: !this.state.isOpen });
        const confirm = () => {
            const accessToken = this.props.token;
            const headers = {
                'Authorization': `Token ${accessToken}`,
                'Content-Type': 'application/json'
            };
            fetch(
                `${BaseUrl}/api/customers/training/${uuid}/archive/`,
                { headers, method: 'POST', body: JSON.stringify({ uuid: uuid }) }
            ).then(
                () => {
                    toggle()
                    window.location.reload()
                }
            )
        }
        return (
            <Fragment>
                <Button color='danger' onClick={toggle}>
                    <i className='fa fa-trash'> </i>
                </Button>
                <Dialog
                    isOpen={this.state.isOpen}
                    toggle={toggle}
                    confirm={confirm}
                    title={'Schulung löschen'}
                >
                    Wirklich löschen?
                </Dialog>
            </Fragment>

        )
    }
}

class TrainingLinkActions extends Component {

    constructor(props) {
        super(props);
        this._uuid = props.uuid
    }

    render() {
        const uuid = this._uuid;
        return <ButtonGroup>
            <TrainingOverviewLink uuid={uuid} />
            <TrainingArchive uuid={uuid} />
        </ButtonGroup>
    }
}

const trainingListColumns = [
    {
        
        dataField: 'rowIndex',
        formatter: (cell, row, rowIndex) => rowIndex + 1,
        align: 'center',
        headerAlign: 'center'
    },
    {
        text: 'Kunde',
        dataField: 'customer_name',
        classes: 'ellipsis',
        title: true,
        sort: true
    },
    {
        text: 'Name',
        dataField: 'name',
        classes: 'ellipsis',
        title: true,
        sort: true
    },
    {
        text: 'Verantwortlicher',
        dataField: 'contact',
        classes: 'ellipsis',
        title: true,
        sort: true
    },
    {
        text: 'Start',
        sort: true,
        dataField: 'start_at',
        formatter: dateCell
    },
    {
        text: 'Ende',
        sort: true,
        dataField: 'end_at',
        formatter: dateCell
    },
    {
        text: 'Registriert',
        sort: true,
        dataField: 'registered',
        formatter: registered => <span>{Math.round(registered)} %</span>
    },
    {
        text: 'Codes',
        sort: true,
        dataField: 'total',
        formatter: total => <span>{total}</span>
    },
    {
        text: '',
        sort: false,
        dataField: 'uuid',
        formatter: uuid => <TrainingLinkActions uuid={uuid} />
    }
];

const { SearchBar, ClearSearchButton } = Search;

@connect(
    state => ({
        token: state.apa.token
    })
)
export default class CurrentTrainingList extends Component {

    state = {
        isLoading: true,
        trainingList: []
    }

    componentDidMount() {
        const accessToken = this.props.token;
        const headers = {
            'Authorization': `Token ${accessToken}`,
            'Content-Type': 'application/json'
        };
        fetch(
            `${BaseUrl}/api/customers/training/`,
            { headers }
        ).then(
            res => res.json()
        ).then(
            res => this.setState({
                isLoading: false,
                trainingList: res
            })
        )
    }

    render() {
        const { trainingList, isLoading } = this.state;
        if (isLoading) {
            return <Loading />
        }
        return (
            <ToolkitProvider
                keyField='id'
                data={trainingList}
                columns={trainingListColumns}
                search
            >
                {
                    props => (
                        <Fragment>
                            <Form>
                                <FormGroup row className={'form-row'}>
                                    <Col>
                                        <SearchBar {...props.searchProps} placeholder='Suche' />
                                        <ClearSearchButton className="btn-secondary"
                                            text='Zurücksetzen' {...props.searchProps} />
                                    </Col>
                                </FormGroup>
                            </Form>
                            <BootstrapTable
                                {...props.baseProps}
                                striped
                                bootstrap4
                                responsive
                                pagination={paginationFactory()}
                            />
                        </Fragment>
                    )

                }
            </ToolkitProvider>
        )
    }

}